/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Instructions_TitleInputs */

const en_login_offline_instructions_title = /** @type {(inputs: Login_Offline_Instructions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activation Instructions:`)
};

const fr_login_offline_instructions_title = /** @type {(inputs: Login_Offline_Instructions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instructions d'Activation :`)
};

const de_login_offline_instructions_title = /** @type {(inputs: Login_Offline_Instructions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivierungsanleitung:`)
};

const it_login_offline_instructions_title = /** @type {(inputs: Login_Offline_Instructions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istruzioni per l'attivazione:`)
};

const ru_login_offline_instructions_title = /** @type {(inputs: Login_Offline_Instructions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Инструкция по активации:`)
};

const es_login_offline_instructions_title = /** @type {(inputs: Login_Offline_Instructions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instrucciones de activación:`)
};

const zh_cn2_login_offline_instructions_title = /** @type {(inputs: Login_Offline_Instructions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`激活说明：`)
};

const ja_login_offline_instructions_title = /** @type {(inputs: Login_Offline_Instructions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティベーション手順:`)
};

const hi_login_offline_instructions_title = /** @type {(inputs: Login_Offline_Instructions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रियण निर्देश:`)
};

const pt_pt2_login_offline_instructions_title = /** @type {(inputs: Login_Offline_Instructions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instruções de ativação:`)
};

/**
* | output |
* | --- |
* | "Activation Instructions:" |
*
* @param {Login_Offline_Instructions_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_instructions_title = /** @type {((inputs?: Login_Offline_Instructions_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Instructions_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_instructions_title(inputs)
	if (locale === "de") return de_login_offline_instructions_title(inputs)
	if (locale === "it") return it_login_offline_instructions_title(inputs)
	if (locale === "ru") return ru_login_offline_instructions_title(inputs)
	if (locale === "es") return es_login_offline_instructions_title(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_instructions_title(inputs)
	if (locale === "ja") return ja_login_offline_instructions_title(inputs)
	if (locale === "hi") return hi_login_offline_instructions_title(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_instructions_title(inputs)
	return en_login_offline_instructions_title(inputs)
});